import { useEffect, useRef, useState } from 'react';
import { inAppWebview } from '../utils/RegexUtils';

export const useLoadedInApp = (userAgent = window.navigator.userAgent) => {
    const initialRender = useRef(true); // track if we're on first render
    const [loadedInApp, setLoadedInApp] = useState(false);

    useEffect(() => {
        if (initialRender.current) {
            const inApp = inAppWebview.test(userAgent);
            setLoadedInApp(inApp);
        } else {
            initialRender.current = false;
        }
    }, [userAgent, setLoadedInApp]);

    return loadedInApp;
};
